import changelogs from '@/root/changelogs';

export const getAppVersion = (): string | null => {
  return Object.keys(changelogs)?.slice?.(-1)?.[0] ?? null;
};
